import React from "react";

import Content from "./Content";
import Hero from "./Hero";
import Group from "./Group";
import Footer from "./Footer";

const Main = () => {
  return (
    <div>
      <Hero />
      <Content />
      <Group />
      <Footer />
    </div>
  );
};

export default Main;
